import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const TODO_COLOR = token('color.background.accent.gray.subtlest', colors.N200);
export const IN_PROGRESS_COLOR = token('color.icon.accent.blue', colors.B500);
export const DONE_COLOR = token('color.icon.accent.green', colors.G500);

export const PROGRESS_BAR_HEIGHT = 6;
export const PROGRESS_BAR_BORDER_RADIUS = 23;
